import React from 'react';
import Select from 'react-select';
import { compareOptionShortLabel, compareOptionSearchFilter } from './versionApi';

// Per-pane version dropdown. Options come from versionApi.fetchCompareOptions and
// are shared by both panes; each pane just holds a different selected ref.
// The CLOSED control shows the short form (version number only — 2026-08-17
// feedback item 4); the open menu keeps the full label so rows stay tellable apart.
const VersionSelect = ({ options, value, onChange, isDisabled }) => {
	const selected = options.find((o) => o.value === value) || null;
	return (
		<Select
			className="compare-version-select"
			classNamePrefix="compare-version-select"
			options={options}
			value={selected}
			onChange={(option) => option && onChange(option.value)}
			isDisabled={isDisabled}
			isSearchable={options.length > 10}
			filterOption={compareOptionSearchFilter}
			placeholder="Select a version…"
			formatOptionLabel={(option, { context }) => (context === 'value' ? compareOptionShortLabel(option) : option.label)}
		/>
	);
};

export default VersionSelect;
